// hooks/useAtualizarDados.ts
import { useState } from "react";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
// --------------------- Import Services ---------------------
import { atualizarRepresentante } from "../../../services/atualizarRepresentanteService";
import { atualizarUsuarioService } from "../../../services/atualizarUsuarioService";

export const useAtualizarRepresentante = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);
  const resetError = () => setError(null);

  const atualizarRepre = async (
    representanteId: number | undefined,
    representanteData: any,
    usuarioId: number | undefined,
    usuarioData: any
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    if (representanteId && representanteData) {
      const representanteDataNovo = {
        ...representanteData,
        representanteId: representanteId,
      };

      const usuarioDataNovo = {
        ...usuarioData,
        celular: numberPadrao(usuarioData.celular),
      };

      try {
        const atualizarDados = await atualizarRepresentante(
          representanteDataNovo
        );

        const atualizarDadosUsuario = await atualizarUsuarioService(
          usuarioId,
          usuarioDataNovo
        );

        if (atualizarDados && atualizarDadosUsuario) {
          setSuccess(true);
          setError(false);
        } else {
          setError(true);
          setSuccess(false);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return { atualizarRepre, isLoading, isSuccess, error, success, resetError };
};
